import React from "react";
import "./rentSpaceText.css";
import RoundedLinkButton from "../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";

export default function RentSpaceText() {
  return (
    <div className="how-it-works-rent-a-room">
      <h3>För dig som vill hyra en lokal</h3>
      <p>
        På Vakansa är vi dedikerade till att göra processen att hitta och hyra lokaler så enkel och problemfri som
        möjligt. Lokaler som är billiga, flexibla och anpassande utifrån era behov.
      </p>
      <p>
        Hitta lediga lokaler som är tillgängliga hos oss här eller låt oss hjälpa dig att hitta den perfekta platsen
        för ditt företag, förening eller organisation idag. Ange ert lokalbehov här nedan för att få kostnadsfria
        förslag!
      </p>
      <RoundedLinkButton label={"Få gratis lokalförslag"} href={"/lokalforslag"} color="green" size="lg" />
    </div>
  )
}